import {
  DeesElement,
  customElement,
  html,
  css,
  cssManager,
  property,
  type TemplateResult,
} from '@design.estate/dees-element';
import { dashboardCardStyles } from './sz-dashboard-card.styles.js';

declare global {
  interface HTMLElementTagNameMap {
    'sz-dns-ssl-card': SzDnsSslCard;
  }
}

@customElement('sz-dns-ssl-card')
export class SzDnsSslCard extends DeesElement {
  public static demo = () => html`
    <div style="padding: 24px; max-width: 400px;">
      <sz-dns-ssl-card
        dnsConfigured
        acmeConfigured
      ></sz-dns-ssl-card>
    </div>
  `;

  public static demoGroups = ['Network'];

  @property({ type: Boolean })
  public accessor dnsConfigured: boolean = false;

  @property({ type: Boolean })
  public accessor acmeConfigured: boolean = false;

  public static styles = [
    cssManager.defaultStyles,
    dashboardCardStyles,
    css`
      .items {
        display: flex;
        flex-direction: column;
        gap: var(--dees-spacing-md);
      }

      .item {
        min-height: 28px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: var(--dees-spacing-md);
      }

      .item-label {
        min-width: 0;
        color: var(--dees-color-text-secondary);
        font-size: var(--dees-font-callout-size);
      }
    `,
  ];

  public render(): TemplateResult {
    return html`
      <dees-tile>
        <div slot="header" class="card-header">
          <div class="header-copy">
            <div class="card-title">DNS & SSL</div>
            <div class="card-subtitle">Automation readiness</div>
          </div>
          <dees-icon icon="lucide:Globe2" .iconSize=${18}></dees-icon>
        </div>

        <div class="card-content">
          <div class="items">
            <div class="item">
              <span class="item-label">Cloudflare DNS</span>
              <dees-badge
                rounded
                .type=${this.dnsConfigured ? 'success' : 'default'}
                .text=${this.dnsConfigured ? 'Configured' : 'Not configured'}
              ></dees-badge>
            </div>
            <div class="item">
              <span class="item-label">ACME · Let’s Encrypt</span>
              <dees-badge
                rounded
                .type=${this.acmeConfigured ? 'success' : 'default'}
                .text=${this.acmeConfigured ? 'Configured' : 'Not configured'}
              ></dees-badge>
            </div>
          </div>
        </div>
      </dees-tile>
    `;
  }
}
